import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

import Attachments from './components/Attachments';
import UploadModal from './components/UploadModal';
import { useStyles } from './styles';

const MyBrandAttachments = ({ title, viewOnly }) => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const [attachments, setAttachments] = useState([]);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const addAttachments = (newAttachments) => {
    setAttachments([...attachments, ...newAttachments]);
  };

  const removeAttachment = (index) => {
    const attachmentsClone = [...attachments];
    attachmentsClone.splice(index, 1);

    setAttachments(attachmentsClone);
  };

  return (
    <div className={classes.wrapper}>
      <h2>{title}</h2>
      <Attachments attachments={attachments} removeAttachment={removeAttachment} />
      {!viewOnly && (
        <Button size="small" color="primary" variant="contained" onClick={handleModalOpen}>
          Upload files
        </Button>
      )}
      <UploadModal
        open={modalOpen}
        handleClose={handleModalClose}
        addAttachments={addAttachments}
      />
    </div>
  );
};

MyBrandAttachments.propTypes = {
  title: PropTypes.string,
  viewOnly: PropTypes.bool,
};

MyBrandAttachments.defaultProps = {
  title: 'Attachments',
  viewOnly: false,
};

export default MyBrandAttachments;
